import {MainRequest} from 'Services/common';

const UrlMap = {
    list: '/aichat/mcp/function',
    detail: '/aichat/mcp/function/get',
    edit: '/aichat/mcp/function/save',
    remove: '/aichat/mcp/function/del',
};
export class McpFunction {
    static list(params: McpFunction.QueryList) {
        return MainRequest.get<SuccessData<McpFunction.List[]>>(
            `${UrlMap.list}/${params?.mcpId}`,
            {
                params,
            },
        )
            .then(res => res.data.data)
            .then(res => {
                return {
                    total: res?.length,
                    data: res,
                };
            });
    }

    static async detail(id: string) {
        return MainRequest.get<SuccessData<McpFunction.Detail>>(
            `${UrlMap.detail}/${id}`,
        ).then(res => res.data.data);
    }

    static async save(data: McpFunction.Form) {
        return MainRequest.post(UrlMap.edit, data);
    }

    static async remove(id: string) {
        return MainRequest.get(`${UrlMap.remove}/${id}`);
    }

    static FieldTypeOptions = ['get', 'post', 'put', 'delete'] as const;
}

export namespace McpFunction {
    export type QueryForm = {};

    interface Schema {
        mcpId: string;
        name: string; //        函数名称
        method: typeof McpFunction.FieldTypeOptions; //        HTTP方法：get, post, put, delete
        url: string; //        接口URL路径
        description: string; //        函数描述
        dataIntro: string; //        数据格式说明
    }

    export interface List extends Schema {
        id: string;
    }

    export interface Detail extends Schema {
        id: string;
    }

    export interface Form extends Schema {
        id?: string;
    }

    export type QueryList = QueryForm & {mcpId: string};
}
